import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { HomeComponent } from './home/home.component';
import { MenuComponent } from './shared/components/menu/menu.component';
import { ContactComponent } from './shared/components/contact/contact.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PhoneNumbersComponent } from './shared/components/phone-numbers/phone-numbers.component';
import { LegislationComponent } from './legislation/legislation.component';
import { AccountabilityComponent } from './accountability/accountability.component';
import { MeetingScheduleComponent } from './meeting-schedule/meeting-schedule.component';
import { RouterLink, RouterModule } from '@angular/router';
import { AboutComdicaComponent } from './about-comdica/about-comdica.component';
import { TermosPoliticasModule } from './termos-politicas/termos-politicas.module';
import { LegislationListComponent } from './legislation/legislation-list/legislation-list.component';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginatorIntl } from './legislation/legislation-list/custom-paginator-intl';
import { TitlecasePipe } from './titlecase.pipe';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AccountabilityComponent,
    LegislationComponent,
    MeetingScheduleComponent,
    AboutComdicaComponent,
    LegislationListComponent,
    TitlecasePipe
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    FormsModule,
    ContactComponent,
    FooterComponent,
    MenuComponent,
    PhoneNumbersComponent,
    TermosPoliticasModule,
    MatPaginatorModule,
    RouterLink
  ],
  providers: [
    {provide: MatPaginatorIntl, useClass: CustomPaginatorIntl}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
